import api from 'services/api';
import config from 'config';
import React, { useState } from 'react';
import { formatDate } from 'components/formatos';

function ESTABELECIMENTOAPROVAAVALIACAO ({idestabelecimento, avaliacoes, setAvaliacoes}){
    const refreshAvaliacoes = () => {
        api.get(`${config.ESTABELECIMENTOS_AVALIACAO}?id=${idestabelecimento}&aprovado=N`)
       .then(response => {
          setAvaliacoes(response.data)
        })
        .catch(err => console.log(err));
    };

    const aprovaravaliacoes = (id,index) => {
        api.post(`${config.ADM_ESTABELECIMENTOS_AVALIACAO}/aprovar/${id}`,
            { ies_aprovacao: 'S', den_resposta: avaliacoes[index].den_resposta })	
            .then(response => {
                refreshAvaliacoes();
              })
    };

    const deletaravaliacoes = (id) => {
        api.delete(`${config.ADM_ESTABELECIMENTOS_AVALIACAO}/aprovar/${id}`)
            .then(response => {
                refreshAvaliacoes();
              })
    };
    const setValor = (id, index, valor) => {
        const newAvaliacoes = [...avaliacoes];
        newAvaliacoes[index].den_resposta = valor;
        setAvaliacoes(newAvaliacoes);
    }

    return <>
    <table className="table table-striped table-bordered table-hover">
        <thead>
            <tr>
                <th>id</th>
                <th>data</th>
                <th>descricao</th>
                <th>resposta</th>
                <th>acao</th>  
            </tr> 
        </thead>
        <tbody>
            {avaliacoes.map((item,index) => (
                <tr key={item.id_avaliacao}>
                    <td>{item.id_avaliacao}</td>
                    <td>{formatDate(item.datahora)}</td>
                    <td>{item.den_avaliacao}</td>
                    <td><input type='text' value={item.den_resposta}
                               onChange={(e)=>setValor(item.id_avaliacao,index,e.target.value)} /></td>
                    <td>
                        <button type='button' className='btn btn-primary' 
                                onClick={() => aprovaravaliacoes(item.id_avaliacao,index)}>
                            ✔️ Aprovar
                        </button>
                        <button type='button'
                            className='btn btn-danger' 
                            onClick={() => deletaravaliacoes(item.id_avaliacao,index)}>
                            🗑️ Deletar
                        </button>
                    </td>
                </tr>
            ))}
        </tbody>
    </table>
</>;
};

export default ESTABELECIMENTOAPROVAAVALIACAO;